import React, { useState } from "react";
import { auth } from "../../../firebase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import Container from "react-bootstrap/Container";
import { useNavigate, Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { CardText, CardTitle, Col, Row } from "reactstrap";
import ControlledTextField from "../../../components/ControlledTextField";
import "./index.css";
import { toast } from "react-toastify";
import GoogleIcon from "../../../assets/icons/google-icon.png";
import logo from "../../../assets/images/logoWOBGD.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import authBackground from "../../../assets/images/authBackground.PNG";

type FormData = {
  email: string;
  password: string;
  confirmPassword: string;
  countryCode?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
};

const SignUp: React.FC = () => {
  const navigate = useNavigate();

  const [isSignUpping, setIsSignUpping] = useState(false);

  const { control, handleSubmit, watch } = useForm<FormData>();

  const password = watch("password");

  const signUp = async (email: string, password: string) => {
    setIsSignUpping(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      if (userCredential.user) {
        await sendEmailVerification(userCredential.user);
        toast.success("Verification email sent. Please check your inbox.");
      }
      setIsSignUpping(false);
      toast.success("Account Created Successfully! Please verify your email.");
      navigate("/sign-in");
    } catch (error: any) {
      console.error("Error during email/password sign-up: ", error);
      toast.error(
        error.code || "Something wrong please check your email and password."
      );
      setIsSignUpping(false);
    }
  };

  const googleSignUp = async () => {
    const provider = new GoogleAuthProvider();

    try {
      await signInWithPopup(auth, provider);
      toast.success("Google Account Signed UP Successfully!");
      navigate("/");
    } catch (error: any) {
      console.error("Error signing in with Google: ", error);
      toast.error(error.message || "Failed to sign in with Google.");
    }
  };

  const onSubmit = (data: FormData) => {
    signUp(data.email, data.password);
  };

  return (
    <div className="auth-page-hero"
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${authBackground}) no-repeat center center`,
        backgroundSize: 'cover',
      }}>
      <div className="">
        <Container
          fluid
          className="d-flex align-items-center justify-content-center auth-wrapper auth-cover"
        >
          <div
            className="p-4 card-signin shadow-lg text-center"
            style={{ maxWidth: "450px", width: "100%" }}
          >
            <div className="imageAreaBackgroundColor my-1">
              <img
                src={logo}
                alt="loginimage"
                style={{ width: "200px" }}
              />
            </div>
            <CardTitle tag="h2" className="fw-bold mb-1">
              Welcome to Curry King Super Admin!
            </CardTitle>
            <CardText className="mb-1">
              Please sign-up to your account and start the adventure
            </CardText>
            <Form
              className="auth-login-form mt-1"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Row className="mt-1">
                <Col className="">
                  <ControlledTextField
                    label=""
                    inputName="firstName"
                    inputType="text"
                    placeholder="Enter Your First Name"
                    isRequired={false}
                    control={control}
                  />
                </Col>
                <Col md="6" className="">
                  <ControlledTextField
                    label=""
                    inputName="lastName"
                    inputType="text"
                    placeholder="Enter Your Last Name"
                    isRequired={false}
                    control={control}
                  />
                </Col>
              </Row>
              <div className="mb-1">
                <ControlledTextField
                  label={""}
                  inputName={"email"}
                  inputType={"email"}
                  placeholder={"Enter Your Email"}
                  isRequired={true}
                  control={control}
                />
              </div>
              <div className="mb-1">
                <ControlledTextField
                  label={""}
                  inputName={"password"}
                  isRequired={true}
                  placeholder={"Enter Password"}
                  inputType={"password"}
                  control={control}
                  rules={{ required: true }}
                />
              </div>
              <div className="mb-1">
                <ControlledTextField
                  label={""}
                  inputName={"confirmPassword"}
                  isRequired={true}
                  placeholder={"Confirm Password"}
                  inputType={"password"}
                  control={control}
                  rules={{
                    required: true,
                    validate: (value: any) =>
                      value === password || "Passwords do not match",
                  }}
                />
              </div>
              <div className="mb-2 mt-4">
                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"lk"}
                      inputClass="form-control"
                      containerClass="mb-1"
                      inputProps={{
                        name: "phoneNumber",
                        required: true,
                        autoFocus: true,
                      }}
                    />
                  )}
                />
              </div>

              <div className="d-grid">
                {isSignUpping ? (<button
                  type="submit"
                  className="btn my-2 py-2 btn-signin-color btn-block"
                  disabled={true}
                >
                  <FontAwesomeIcon icon={faSpinner} spin className="me-2" />Creating Account
                </button>) : (<button
                  type="submit"
                  className="btn my-2 py-2 btn-signin-color btn-block"
                >
                  Sign Up
                </button>)}

              </div>

              <div className="text-center mb-1">
                <p>
                  Already have an account? Please{" "}
                  <Link to="/sign-in">
                    <div className="btn text-link-color">SignIn</div>
                  </Link>
                </p>
              </div>

              <div className="d-grid mb-2">
                <button
                  className="btn text-link-color d-flex align-items-center justify-content-center"
                  onClick={googleSignUp}
                >
                  <img
                    src={GoogleIcon}
                    alt="Google Icon"
                    style={{ width: "20px", marginRight: "10px" }}
                  />
                  Sign Up with Google
                </button>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default SignUp;
